import {
  API_HOST,
  getHttpDeleteOptions,
  getHttpGetOptions,
  getHttpPostOptions,
  getHttpPutOptions
} from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/member`;
const getSpecificEndpoint = (externalReference) => `${getEndpoint()}/${externalReference}`;

export const getCreateMemberRequest = (member) => [getEndpoint(), getHttpPostOptions(member)];

const getViewAllMembersEndpoint = (externalReference) => `${getEndpoint()}/programme/${externalReference}`;
export const getViewAllMembersRequest = (externalReference) => [
  getViewAllMembersEndpoint(externalReference),
  getHttpGetOptions()
];

export const getUpdateMemberRequest = (member) => [getEndpoint(), getHttpPutOptions(member)];

export const getDeleteMemberRequest = (externalReference) => [
  getSpecificEndpoint(externalReference),
  getHttpDeleteOptions()
];

const getDownloadMemberExcelEndpoint = () => `${getEndpoint()}/excel/download/`;
export const getDownloadMemberExcelRequest = (programmeExternalReference) => [
  getDownloadMemberExcelEndpoint(),
  getHttpPostOptions({ programmeExternalReference })
];

const getViewTribeMembersEndpoint = (externalReference) => `${getEndpoint()}/tribe-members/${externalReference}`;
export const getViewTribeMembersRequest = (externalReference) => [
  getViewTribeMembersEndpoint(externalReference),
  getHttpGetOptions()
];

export const getViewMemberRequest = (externalReference) => [
  getSpecificEndpoint(externalReference),
  getHttpGetOptions()
];

const getViewMemberProfileEndpoint = (externalReference) => `${getSpecificEndpoint(externalReference)}/profile`;
export const getViewMemberProfileRequest = (externalReference) => [
  getViewMemberProfileEndpoint(externalReference),
  getHttpGetOptions()
];
